import { __awaiter, __decorate, __metadata } from "tslib";
import { UnitKeys } from './user-settings-store.types';
import Constants from '@/types/constants';
import { userTimezone } from '@masternaut/ifta-reporting-types';
import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
export const userSettingsStoreModuleName = 'userSettingsStore';
let UserDetailsModule = class UserDetailsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.branding = 'masternaut';
        this.customerId = '';
        this.personId = '';
        this.groupId = '';
        this.locale = '';
        this.skin = '';
        this.timezone = '';
        this.timezoneCodes = {};
        this.unitSettings = {
            co2DistanceRatioUnit: '',
            distanceUnit: Constants.UNITS.MILES,
            fuelConsumptionUnit: '',
            fuelUnit: '',
            speedUnit: '',
        };
    }
    get getCustomerId() {
        return this.customerId;
    }
    get getUnitSettings() {
        return this.unitSettings;
    }
    get getUserSettings() {
        return {
            branding: this.branding,
            customerId: this.customerId,
            groupId: this.groupId,
            locale: this.locale,
            personId: this.personId,
            skin: this.skin,
            timezone: this.timezone,
            unitSettings: this.unitSettings,
        };
    }
    setUserDetails(userSettings) {
        return __awaiter(this, void 0, void 0, function* () {
            const units = userSettings.unitSettings.map((setting) => {
                const unit_keys = Object.values(Constants.UNIT_SETTINGS);
                if (unit_keys.includes(setting.key)) {
                    return { [UnitKeys[setting.key]]: setting.value };
                }
                return;
            });
            return {
                branding: userSettings.branding,
                customerId: userSettings.customerId,
                groupId: userSettings.groupId,
                locale: userSettings.locale,
                personId: userSettings.personId,
                skin: userSettings.skin,
                timezone: (userTimezone === null || userTimezone === void 0 ? void 0 : userTimezone[userSettings.timezoneId]) || 'Europe/London',
                unitSettings: Object.assign({}, ...units),
            };
        });
    }
    setLocale(newLocale) {
        this.locale = newLocale;
    }
};
__decorate([
    MutationAction,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], UserDetailsModule.prototype, "setUserDetails", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserDetailsModule.prototype, "setLocale", null);
UserDetailsModule = __decorate([
    Module({
        name: userSettingsStoreModuleName,
        namespaced: true,
        stateFactory: true,
    })
], UserDetailsModule);
export { UserDetailsModule };
